export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]

export const NotificationType = {
  RIDE_PUBLISHED: 'RIDE_PUBLISHED',
  RIDE_CANCELLED: 'RIDE_CANCELLED',
  TRIP_PUBLISHED: 'TRIP_PUBLISHED',
  TRIP_CANCELLED: 'TRIP_CANCELLED',
  POST_PUBLISHED: 'POST_PUBLISHED',
  COMMENT_REPLY: 'COMMENT_REPLY',
  RIDE_REMINDER: 'RIDE_REMINDER',
  RIDE_UPDATED: 'RIDE_UPDATED',
  RIDE_GROUP_REMOVED: 'RIDE_GROUP_REMOVED',
  RIDE_JOINED: 'RIDE_JOINED',
  COMMENT_ON_MY_PUBLICATION: 'COMMENT_ON_MY_PUBLICATION',
  TEAM_INVITATION: 'TEAM_INVITATION',
  CONTENT_REPORTED: 'CONTENT_REPORTED',
} as const
